"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CardFooter = function CardFooter(_ref) {
  var children = _ref.children,
      className = _ref.className,
      otherProps = _ref.otherProps;
  return /*#__PURE__*/_react.default.createElement(StyledCardFooter, _extends({
    className: className
  }, otherProps), children);
};

var StyledCardFooter = _styledComponents.default.div.withConfig({
  displayName: "StyledCardFooter"
})(["padding:1.6rem;border-top:2px solid #f0f1f3;border-radius:0 0 0.5rem 0.5rem;"]);

CardFooter.propTypes = {
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  otherProps: _propTypes.object
};
var _default = CardFooter;
exports.default = _default;